import React, { useState } from "react";
import { ThemeProvider } from "@mui/material";
import { addToStorage, getFromStorage } from "@utilities/storageService";
import { themeCreator } from "@theme/base";

export const ThemeContext = React.createContext((themeName: string): void => {});

const ThemeProviderWrapper = ({ children }: { children?: React.ReactNode }) => {
    const curThemeName = getFromStorage("appTheme") || "PureLightTheme";
    const [themeName, _setThemeName] = useState(curThemeName);
    const theme = themeCreator(themeName);
    const setThemeName = (themeName: string): void => {
        addToStorage("appTheme", themeName);
        _setThemeName(themeName);
    };

    return (
        <ThemeContext.Provider value={setThemeName}>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </ThemeContext.Provider>
    );
};

export default ThemeProviderWrapper;
